import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=ac227072&scoped=true"
import script from "../js/Home?vue&type=script&lang=js&external"
export * from "../js/Home?vue&type=script&lang=js&external"
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=ac227072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac227072",
  null
  
)

export default component.exports